<template>
  <Form :model="formData" :rules="formRules" :ref="`rulusForm${i}`" class="mr20 inline-b dynamic-form">
    <FormItem label="" prop="start" >
      <Input v-model="formData.start" size="small" :disabled="!(i===0 && len===1) || disable">
      </Input>
    </FormItem>
    <div class="dash"><span></span></div>
    <FormItem label="" prop="end" >
      <Input v-model="formData.end" size="small" :disabled="disable || (len>1 && !isLast)" @on-blur="changeEnd"></Input>
    </FormItem>
    <span>天：</span>
    <!-- <div class="error-color" :class="{block:endErr || startErr}">请输入正确的数字</div> -->
    <FormItem label="" prop="waveValue" class="w-80">
      <Input v-model="formData.waveValue" size="small" :disabled="disable">
        <span slot="append">%</span>
      </Input>
    </FormItem>
    <Icon v-if="isLast && !disable" class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="removeForm"></Icon>
  </Form>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    renewDay:{
      type:Number,
      default:0
    },
    start:{
      //type: Number,
      default:0
    },
    i:{
      type:Number,
      default:0
    },
    disable:{
      type: Boolean,
      default:false
    },
    len:{
      type:Number,
      default:0
    },
    waveData:{
      type:Object,
      default:null
    }
  },
  created(){
    for( const key in this.formData) {
      this.formData[key] = this.waveData[key]
    }
    if(this.i){
      this.formData.start = this.start
    }
  },
  // watch:{
  //   waveData:{
  //     deep:true,
  //     handler(val){
  //       console.log(val)
  //     }
  //   }
  // },
  data () {
    const validateWaveNumber = (require,value,callback) => {
      const pattern = /^[1-9]\d*$/
      if(pattern.test(value) && +value <= 100){
         callback()
      }else{
       callback(new Error(' '))
      }
    }
    const validateStart = (require,value,callback) => {
      const pattern = /^[1-9]\d*$/
      let bool = true
      if(this.formData.end) {
        bool = (value <= this.formData.end)
      }

      if(pattern.test(value) && +value <= this.renewDay && bool){
         callback()
      }else{
       callback(new Error(' '))
      }
    }
    const validateEnd = (require,value,callback) => {
      const pattern = /^[1-9]\d*$/
      if(pattern.test(value) && +value <= this.renewDay && +value >= this.formData.start){
         callback()
      }else{
       callback(new Error(' '))
      }
    }
    return {
      endErr:false,
      startErr:false,
      formData:{
        start:'',
        end:'',
        waveValue:'',
      },
      formRules:{
        start:[{required: true,validator:validateStart, type:'number',trigger:'blur'}],
        end:[{required: true,validator:validateEnd, type:'number',trigger:'blur'}],
        waveValue:[{required: true,type:'number', validator:validateWaveNumber,trigger:'blur'}],
      }
    };
  },
  computed:{
    isLast(){
      if(this.i>0){
        return this.i === this.len-1
      }else {
        return false
      }
    }
  },
  methods: {
    changeEnd(val) {
      if(+this.formData.end <= this.renewDay) {
        const data = {
          i: this.i,
          preEnd: this.formData.end
        }
        this.$emit('change-end',data)
      }
    },
    removeForm(){
      this.$emit('remove-form',this.start)
    },
    formValidate() {
      let obj = {}
      this.$refs[`rulusForm${this.i}`].validate( bool => {
        if(bool){
            obj = this.formData
          // console.log('success')
        }else{
            obj = false
        }
      })
      return obj
    }
  }
}
</script>

<style lang="css" scoped>
.ivu-form-item {
  display: inline-block;
  width: 60px;
}
.dash {
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  line-height: 24px;
  text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 8px;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }
  .w-80 {
    width: 80px;
  }
   .block {
    display: block;
  }
   .error-color{
    position: absolute;
    bottom: 0;
    display: none;
  }
  .basic-rules .ivu-form-item-error-tip {
    top: 100%;
    left: 0;
  }
  .delete-icon {
    padding-top: 0px;
    position: relative;
    top: -8px;
  }

</style>